<template>
  <div class="compoent_container">
    <el-card class="box_card base_box">
      <div slot="header" class="card_header">
        <p class="title">患者详情</p>
      </div>
      <!-- 基础信息 -->
      <userInfo :memberId="memberId" v-if="isReload"/>
    </el-card>
    <el-card class="box_card">
      <div slot="header" class="card_header">
        <el-menu :default-active="menuActiveIndex" class="menus" mode="horizontal" @select="changeMenu" background-color="#324157" text-color="#fff" active-text-color="#409EFF">
            <el-menu-item index="1">基础信息</el-menu-item>
            <el-menu-item index="2">健康管理</el-menu-item>
        </el-menu>
      </div>
      <el-scrollbar :style="{height: scrollHeight}">
        <div v-if="menuActiveIndex == '1'">
          <!-- <base-member-info :memberId="memberId" v-if="!isEdit" @isEdit="chageEditState"/> -->
          <edit-information v-if="editType" path="memberDetail"  :type="parseInt(editType)" @handleEdit="handleEdit" :memberId="memberId" />

          <member-info :memberId="memberId" :isShow="isEdit" :pageType="'1'" ref="memberDom" v-if="isEdit"  @isEdit="chageEditState"/>
        </div>
        <div v-if="menuActiveIndex == '2'">
          <!-- <el-menu default-active="'1'" mode="horizontal" class="child_menus">
            <el-menu-item index="1">系统报告</el-menu-item>
            <el-menu-item index="2">服务管理</el-menu-item>
          </el-menu> -->
          <el-tabs  v-model="tabPaneIndex" type="card" @tab-click="changeTabPaneIndex">
            <el-tab-pane label="系统报告" name="1"></el-tab-pane>
            <el-tab-pane label="服务管理" name="2"></el-tab-pane>
          </el-tabs>
          <healthWeekly  :memberId="memberId" :pageType="'1'" v-if="!isShowQuotaState && tabPaneIndex == '1'" @toDetail="toDetail" />
          <quotaTest :memberId="memberId" :pageType="'1'"  v-if="isShowQuotaState && tabPaneIndex == '1'" @closeDetail="closeDetail" />
          <serviceWeekly :memberId="memberId" :pageType="'1'" v-if="!isShowServiceState && tabPaneIndex == '2'" @toServiceDetail="toServiceDetail" />
          <serviceDetail :memberForm="memberForm" :serveiceDetail="serveiceDetail" :pageType="'1'" v-if="isShowServiceState && tabPaneIndex == '2'" @closeServiceDetail="closeServiceDetail" />
        </div>
      </el-scrollbar>
    </el-card>
  </div>
</template>

<script>
let self = this;
import editInformation from './editInformation1.vue'
import userInfo from '@/components/common/user/user_info'; // 患者详情
import memberInfo from '@/components/common/user/member_info'; // 可编辑会员表单组件
import baseMemberInfo from '@/components/common/user/base_member_info'; // 不可编辑会员详情
import quotaTest from '@/components/common/user/quota_test'; // 指标详情
import healthWeekly from '@/components/common/user/health_weekly'; // 周报
import serviceWeekly from '@/components/common/user/service_weekly'; // 服务周报
import serviceDetail from '@/components/common/user/service_detail'; // 周报详情
import { getDate, getHms, objDeepCopy } from '@/utils/index';
export default {
  components: { userInfo, memberInfo, baseMemberInfo, quotaTest, healthWeekly, serviceWeekly, serviceDetail, editInformation },
  prop: {

  },
  watch: {

  },
  created() {
    console.log(this.$route.query);
    self = this;
    this.$nextTick(() => {
      self.initScrollHeight();
    });
    this.initData();
  },
  data() {
    return this.getDatas();
  },
  methods: {
    // 点击编辑
    handleEdit(val) {
      this.editType = 0
      this.$nextTick(_=>{
        this.editType = val;
      })
    },
    toDetail(b) { // 显示详情
      this.isShowQuotaState = b;
    },
    closeDetail(b) {
      this.isShowQuotaState = b;
    },
    changeTabPaneIndex(e) {
      if (e.name == '2') {
        this.isShowServiceState = false;
      }
    },
    toServiceDetail(b, item) {
      this.isShowServiceState = b;
      this.serveiceDetail = item;
    },
    closeServiceDetail(b) {
      this.isShowServiceState = b;
    },
    chageEditState(state) { // 修改编辑
      this.isEdit = state;
      this.isReload = false;
      this.$nextTick(() => {
          this.isReload = true;
      });
      if (!state) {
        // this.initDetailForm();
      }
    },
    initScrollHeight() { // 动态获取滚动区域高度
      const classContentHeight = document.getElementsByClassName('content')[0].offsetHeight;
      const classBaseBoxHeight = document.getElementsByClassName('base_box')[0].offsetHeight;
      const classMenusHeight = document.getElementsByClassName('menus')[0].offsetHeight;
      const otherHeight = 85;
      self.scrollHeight = classContentHeight - classBaseBoxHeight - classMenusHeight - otherHeight + 'px';
      console.log('scrollHeight:', self.scrollHeight);
    },
    changeMenu(key, keyPath) { // 切换菜单
      this.menuActiveIndex = key;
    },
    initData() { // 初始化表单
      self.memberId = Number(self.$route.query.memberId);
    },
    getDatas() {
      return {
        loginData: JSON.parse(localStorage.getItem('loginData')) || {}, // 登录药企基本信息
        yqData: JSON.parse(localStorage.getItem('yqData')) || {}, // 登录药企基本信息
        memberId: null,
        baseInfo: {}, // 不可编辑信息
        memberForm: {}, // 可编辑信息
        isEdit: false, // 是否编辑
        menuActiveIndex: '1', // 1：基本信息
        tabPaneIndex: '1', // 健康管理 -> 1:系统报告 2：健康服务
        isShowQuotaState: false, // 是否显示检测指标
        isShowServiceState: false, // 是否显示服务详情
        serveiceDetail: {}, // 服务详情object
        isReload:true, // 是否刷新患者详情
        scrollHeight: '475px',
        editType: 1
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .compoent_container /deep/ .el-card__header {
    padding: 0;
  }
  .card_header {
    font-weight: bold;
    font-size: 18px;
    .title {
      padding: 18px 20px;
    }
  }
  .box_card {
    margin-bottom: 10px;
  }
  .compoent_container /deep/ .el-scrollbar__wrap {
     overflow-x: hidden !important;
 }
 .baseInfoBtns {
   text-align: center;
 }
 .child_menus {
   /deep/ .el-menu-item {
     height: 30px;
     line-height: 30px;
   }
 }
</style>
